/******************************************************************************************
 *	Customer Order History Convertor
 *******************************************************************************************
 *
 * Returns customer details, PA History and Renewal Orders as contents of a CSV file.
 *
 */
(function() {


  angular
    .module('rcServices.customerOrderHistoryConvertor', [])
    .service('CustomerOrderHistoryConvertor', customerOrderHistoryConverter);
  /* @ngInject */
  function customerOrderHistoryConverter(
    _,
    MARKET_SEGMENTS,
    PRODUCT_LICENSE_TYPES,
    CSV_ROW_SEPARATOR,
    $filter,
    $translate,
    $locale,
    ArrayToCsv,
    feature,
    productToProdName,
    ResellerPlanTypes,
    translationUtils
  ) {
    this.getCsvContents = function(
      customer,
      purchases,
      renewals,
      orders,
      selectLoyaltyProgram,
      renewalQuote,
      products,
      enterpriseProducts
    ) {

      var shouldShowOrderHistory = feature.isEnabled("temp_order_history_csv");
      //Customer Details to be placed above the order history date
      var customerDetails = [
        {
          label: $translate.instant('customerDetails.orderHistoryCsv.labels.name'),
          value: customer.name
        },
        {
          label: $translate.instant('customerDetails.orderHistoryCsv.labels.vipNumber'),
          value: customer.vipnumber
        },
        {
          label: $translate.instant('customerDetails.orderHistoryCsv.labels.type'),
          value: ResellerPlanTypes.getResellerPlanTypeLabel(customer.normalizedPlanTypes)
        },
        {
          label: $translate.instant('customerDetails.orderHistoryCsv.labels.anniversaryDate'),
          value: $filter('rcDate')(customer.anniversaryDate)
        },
        {
          label: $translate.instant('customerDetails.orderHistoryCsv.labels.marketSegment'),
          value: translationUtils.sanitizeSafeInstant(MARKET_SEGMENTS[customer.marketSegment].label)
        },
        {
          label: $translate.instant('customerDetails.orderHistoryCsv.labels.managedBy'),
          value: $filter('personName')(customer.managedBy)
        },
        {
          label: $translate.instant('customerDetails.orderHistoryCsv.labels.address'),
          value: $filter('address')(customer.address, true) //Inline address because HTML markup doesn't work in Excel
        }
      ];

      //Select Loyalty Program
      if (selectLoyaltyProgram) {
        // insert before address, after the membership status above. When removing the flag,
        // combine these with the membership status splice.
        customerDetails.splice(
          customerDetails.length - 1,
          0,
          {
            label: $translate.instant('customerDetails.orderHistoryCsv.labels.membershipStatus'),
            value: $translate.instant('customerLoyaltyPrograms.select.name')
          },
          {
            label: $translate.instant('customerDetails.orderHistoryCsv.labels.discountLevel'),
            value: $translate.instant('customerLoyaltyPrograms.select.level', {
              level: selectLoyaltyProgram.level
            })
          }
        );

        if (selectLoyaltyProgram.hasThreeYearCommit()) {
          var committedSeatCount =
            selectLoyaltyProgram.features.THREE_YEAR_COMMIT.committedSeatCount;
          var startDate = selectLoyaltyProgram.features.THREE_YEAR_COMMIT.startDate;
          var endDate = selectLoyaltyProgram.features.THREE_YEAR_COMMIT.endDate;

          if (selectLoyaltyProgram.isEnrolledThreeYearCommit()) {
            customerDetails.splice(
              customerDetails.length - 1,
              0,
              {
                label: $translate.instant('customerDetails.orderHistoryCsv.labels.3yearCommit'),
                value: $filter('rcDate')(startDate) + ' - ' + $filter('rcDate')(endDate)
              },
              {
                label: $translate.instant(
                  'customerDetails.orderHistoryCsv.labels.licenseCommitment'
                ),
                value:
                  committedSeatCount === 1
                    ? committedSeatCount + ' ' + $translate.instant('words.license')
                    : committedSeatCount + ' ' + $translate.instant('words.licenses')
              }
            );
          } else if (selectLoyaltyProgram.isEligibleThreeYearCommit()) {
            customerDetails.splice(
              customerDetails.length - 1,
              0,
              {
                label: $translate.instant('customerDetails.orderHistoryCsv.labels.3yearCommit'),
                value: $translate.instant('loyaltyMembershipModal.notEnrolled.status')
              },
              {
                label: $translate.instant(
                  'customerDetails.orderHistoryCsv.labels.licenseCommitment'
                ),
                value:
                  committedSeatCount > 0
                    ? $translate.instant('loyaltyMembershipModal.notEnrolled.licenseCommitment', {
                        seatCount: committedSeatCount
                      })
                    : $translate.instant(
                        'loyaltyMembershipModal.notEnrolled.editableLicenseCommitment'
                      )
              }
            );
          }
        }
      }

      var licensesAndStatus = [];
      // License delegation information
      licensesAndStatus.push(
        _.assign(
          {
            plans: $translate.instant(
              'customerDetails.customerDetailsCsv.licensesAndStatus.labels.plans'
            ),
            type: $translate.instant(
              'customerDetails.customerDetailsCsv.licensesAndStatus.labels.type'
            ),
            licenseType: $translate.instant(
              'customerDetails.customerDetailsCsv.licensesAndStatus.labels.licenseType'
            ),
            language: $translate.instant(
              'customerDetails.customerDetailsCsv.licensesAndStatus.labels.language'
            )
          },
          getSeatCountObj({
            isUnlimited: false,
            productData: {
              paidSeatCount: $translate.instant(
                'customerDetails.customerDetailsCsv.licensesAndStatus.labels.paid'
              ),
              unpaidSeatCount: $translate.instant(
                'customerDetails.customerDetailsCsv.licensesAndStatus.labels.pending'
              ),
              activeSeatCount: $translate.instant(
                'customerDetails.customerDetailsCsv.licensesAndStatus.labels.active'
              ),
              availableSeatCount: $translate.instant(
                'customerDetails.customerDetailsCsv.licensesAndStatus.labels.available'
              ),
              totalSeatCount: $translate.instant(
                'customerDetails.customerDetailsCsv.licensesAndStatus.labels.total'
              )
            }
          })
        )
      );

      if (products) {
        if (products.userLicensedList) {
          _.forEach(products.userLicensedList, function(userLicenseData) {
            var languageValue = '';
            if (userLicenseData.product.hasLicenseLanguageSplit) {
              _.forEach(userLicenseData.product.languageQuantities, function(lang) {
                if (languageValue.length > 0) {
                  languageValue += ', ';
                }
                languageValue += translationUtils.sanitizeSafeInstant($filter('regionCodeToLanguage')(lang.language));
                languageValue += ' (' + lang.totalSeatCount + ')';
              });
            } else {
              languageValue = translationUtils.sanitizeSafeInstant(
                $filter('regionCodeToLanguage')(userLicenseData.product.language)
              );
            }
            licensesAndStatus.push(
              _.assign(
                {
                  plans: translationUtils.sanitizeSafeInstant(
                    $filter('productToProductName')(userLicenseData.product)
                  ),
                  type: $translate.instant('planType.team'),
                  licenseType: $translate.instant('global.licenseTypes.user.singular'),
                  language: languageValue
                },
                getSeatCountObj({
                  isUnlimited: userLicenseData.hasUnlimitedLicenses,
                  productData: userLicenseData
                })
              )
            );
          });
        }
        if (products.deviceLicensedList) {
          licensesAndStatus = _.union(
            licensesAndStatus,
            _.map(products.deviceLicensedList, function(deviceLicenseData) {
              return _.assign(
                {
                  plans: translationUtils.sanitizeSafeInstant(
                    $filter('productToProductName')(deviceLicenseData.product)
                  ),
                  type: $translate.instant('planType.team'),
                  licenseType: $translate.instant('global.licenseTypes.device.singular'),
                  language: translationUtils.sanitizeSafeInstant(
                    $filter('regionCodeToLanguage')(deviceLicenseData.product.language)
                  )
                },
                getSeatCountObj({
                  isUnlimited: deviceLicenseData.hasUnlimitedLicenses,
                  productData: deviceLicenseData
                })
              );
            })
          );
        }

        if (products.consumableLicensedList) {
          licensesAndStatus = _.union(
            licensesAndStatus,
            _.map(products.consumableLicensedList, function(consumableLicenseData) {
              return _.assign(
                {
                  plans: translationUtils.sanitizeSafeInstant($filter('productToProductName')(consumableLicenseData)),
                  type: $translate.instant('planType.team'),
                  licenseType: consumableLicenseData.getConsumableUnits(),
                  language: '-'
                },
                getSeatCountObj({
                  isConsolidatedProduct: true,
                  isUnlimited: consumableLicenseData.hasUnlimitedLicenses,
                  productData: consumableLicenseData
                })
              );
            })
          );
        }
      }
      if (enterpriseProducts) {
        if (enterpriseProducts.userLicensedList) {
          licensesAndStatus = _.union(
            licensesAndStatus,
            _.map(enterpriseProducts.userLicensedList, function(userLicenseData) {
              return _.assign(
                {
                  plans: translationUtils.sanitizeSafeInstant(
                    $filter('productToProductName')(userLicenseData.product)
                  ),
                  type: $translate.instant('planType.enterprise'),
                  licenseType: $translate.instant('global.licenseTypes.user.singular'),
                  language: translationUtils.sanitizeSafeInstant(
                    $filter('regionCodeToLanguage')(userLicenseData.product.language)
                  )
                },
                getSeatCountObj({
                  isUnlimited: userLicenseData.hasUnlimitedLicenses,
                  productData: userLicenseData
                })
              );
            })
          );
        }

        if (enterpriseProducts.deviceLicensedList) {
          licensesAndStatus = _.union(
            licensesAndStatus,
            _.map(enterpriseProducts.deviceLicensedList, function(deviceLicenseData) {
              return _.assign(
                {
                  plans: translationUtils.sanitizeSafeInstant(
                    $filter('productToProductName')(deviceLicenseData.product)
                  ),
                  type: $translate.instant('planType.enterprise'),
                  licenseType: $translate.instant('global.licenseTypes.sharedDevice.singular'),
                  language: translationUtils.sanitizeSafeInstant(
                    $filter('regionCodeToLanguage')(deviceLicenseData.product.language)
                  )
                },
                getSeatCountObj({
                  isUnlimited: deviceLicenseData.hasUnlimitedLicenses,
                  productData: deviceLicenseData
                })
              );
            })
          );
        }
        if (enterpriseProducts.consumableLicensedList) {
          licensesAndStatus = _.union(
            licensesAndStatus,
            _.map(enterpriseProducts.consumableLicensedList, function(consumableLicenseData) {
              return _.assign(
                {
                  plans: translationUtils.sanitizeSafeInstant($filter('productToProductName')(consumableLicenseData)),
                  type: $translate.instant('planType.enterprise'),
                  licenseType: consumableLicenseData.getConsumableUnits(),
                  language: '-'
                },
                getSeatCountObj({
                  isConsolidatedProduct: true,
                  isUnlimited: consumableLicenseData.hasUnlimitedLicenses,
                  productData: consumableLicenseData
                })
              );
            })
          );
        }
      }

      var orderHistory = [];

      //Column names
      var columnNames = {
        productName: $translate.instant('customerDetails.orderHistoryCsv.columns.plans'),
        planType: $translate.instant('customerDetails.orderHistoryCsv.columns.planType'),
        licenseType: $translate.instant('customerDetails.orderHistoryCsv.columns.licenseType'),
        licenseCount: $translate.instant('customerDetails.orderHistoryCsv.columns.licenseCount'),
        poNumber: shouldShowOrderHistory
          ? $translate.instant('customerDetails.orderHistoryCsv.columns.poPaNumber')
          : $translate.instant('customerDetails.orderHistoryCsv.columns.poNumber'),
        duration: $translate.instant('customerDetails.orderHistoryCsv.columns.duration'),
        date: $translate.instant('customerDetails.orderHistoryCsv.columns.date'),
        authorizedBy: $translate.instant('customerDetails.orderHistoryCsv.columns.authorizedBy'),
        status: $translate.instant('customerDetails.orderHistoryCsv.columns.status'),
        orderType: $translate.instant('customerDetails.orderHistoryCsv.columns.orderType'),
        fulfilledQuantity: shouldShowOrderHistory
          ? $translate.instant('customerDetails.orderHistoryCsv.columns.fulfilledQuantity')
          : '',
        pendingLicenseQuantity: shouldShowOrderHistory
          ? $translate.instant('customerDetails.orderHistoryCsv.columns.pendingLicenseQuantity')
          : ''
      };

      orderHistory.push(columnNames);

      //Parse purchases
      if (purchases) {
        _.forEach(purchases, function(purchase) {
          _.forEach(purchase.purchaseItems, function(purchaseItem) {
            //Status column is composited from label + date if present
            var status = purchase.statusLabel;
            var statusDate = $filter('rcDate')(purchase.statusDate);
            if (statusDate) {
              status += ' (' + statusDate + ')';
            }

            var isConsumable = _.invoke(purchaseItem, 'product.isConsumptionBasedLicense');

            //Localized license type name
            var licenseType;
            let consumableQuantity;
            if (_.invoke(purchaseItem, 'product.isSharedDeviceLicense')) {
              licenseType = $translate.instant('global.licenseTypes.sharedDevice.singular');
            } else if (
              _.get(purchaseItem, 'product.licenseType') === PRODUCT_LICENSE_TYPES.DEVICE
            ) {
              licenseType = $translate.instant('global.licenseTypes.device.singular');
            } else if (isConsumable) {
              licenseType = _.invoke(purchaseItem, 'product.getConsumableUnits');
              // Calculate the number of units purchased with this order, based on the purchase quantity
              // and the cap of the consumable units per license
              const consumableCap = _.parseInt(purchaseItem.product.getConsumableCap());
              consumableQuantity = consumableCap * purchaseItem.quantity;
            } else {
              licenseType = $translate.instant('global.licenseTypes.user.singular');
            }

            orderHistory.push({
              productName: translationUtils.sanitizeSafeInstant(productToProdName.get(purchaseItem.product)),
              planType: ResellerPlanTypes.getResellerPlanTypeString(
                purchase.entitledPlanType ? [purchase.entitledPlanType] : undefined
              ),
              licenseType: licenseType,
              licenseCount: isConsumable ? consumableQuantity : purchaseItem.quantity,
              poNumber: purchase.poNumber,
              duration: purchase.authorizationDurationMonths,
              date: $filter('rcDate')(purchase.authorizationDate),
              authorizedBy: $filter('personName')(purchase.authorizedBy),
              status: status,
              orderType: $translate.instant('customerDetails.orderHistoryCsv.types.authorization'),
              fulfilledQuantity: shouldShowOrderHistory ? purchaseItem.quantityOrdered : null,
              pendingLicenseQuantity: shouldShowOrderHistory ? purchaseItem.unpaidQuantity : null
            });
          });
        });
      }

      //Parse renewals
      if (renewals && !shouldShowOrderHistory) {
        _.forEach(renewals, function(renewal) {
          _.forEach(renewal.renewalItems, function(renewalItem) {
            var isConsumable = _.invoke(renewalItem, 'product.isConsumptionBasedLicense');
            //Localized license type name
            var licenseType;
            let consumableQuantity;
            if (_.invoke(renewalItem, 'product.isSharedDeviceLicense')) {
              licenseType = $translate.instant('global.licenseTypes.sharedDevice.singular');
            } else if (renewalItem.product.licenseType === PRODUCT_LICENSE_TYPES.DEVICE) {
              licenseType = $translate.instant('global.licenseTypes.device.singular');
            } else if (isConsumable) {
              licenseType = _.invoke(renewalItem, 'product.getConsumableUnits');
              // Calculate the number of units purchased with this order, based on the purchase quantity
              // and the cap of the consumable units per license
              const consumableCap = _.parseInt(renewalItem.product.getConsumableCap());
              consumableQuantity = consumableCap * renewalItem.quantity;
            } else {
              licenseType = $translate.instant('global.licenseTypes.user.singular');
            }

            orderHistory.push({
              productName: translationUtils.sanitizeSafeInstant(productToProdName.get(renewalItem.product)),
              planType: ResellerPlanTypes.getResellerPlanTypeString(
                renewal.entitledPlanType ? [renewal.entitledPlanType] : undefined
              ),
              licenseType: licenseType,
              licenseCount: isConsumable ? consumableQuantity : renewalItem.quantity,
              poNumber: renewal.poNumber,
              duration: null,
              date: $filter('rcDate')(renewal.orderDate),
              authorizedBy: null,
              status: null,
              orderType: $translate.instant('customerDetails.orderHistoryCsv.types.renewal')
            });
          });
        });
      }

      // Renewal Summary (quoting)
      var renewalSectionString = '';
      if (renewalQuote) {
        // Column names
        var summaryColumnNames = {
          product: $translate.instant('customerDetails.renewalSummary.product'),
          partNumber: $translate.instant('customerDetails.renewalSummary.partNumber'),
          smrp: $translate.instant('customerDetails.renewalSummary.smrp'),
          quantity: $translate.instant('customerDetails.renewalSummary.quantity'),
          currency: $translate.instant('customerDetails.renewalSummary.currency'),
          priceGuarantee: $translate.instant('customerDetails.renewalSummary.priceGuarantee')
        };

        // renewalQuote -> Segments -> Currency -> parts / total / sales region / currency symbol
        _.forEach(renewalQuote.segments, function(segment, segmentKey) {
          var renewalSummary = [];
          var summaryTotal = [];

          switch (segment.customerSalesRegion) {
            case 'NA':
              summaryColumnNames.msrp = $translate.instant('customerDetails.renewalSummary.msrp');
              break;
            case 'EMEA':
            case 'APAC':
              summaryColumnNames.msrp = $translate.instant(
                'customerDetails.renewalSummary.recommendedRetailPrice'
              );
              break;
            case 'JP':
              summaryColumnNames.msrp = $translate.instant(
                'customerDetails.renewalSummary.estimatedRetailPrice'
              );
              break;
            default:
              summaryColumnNames.msrp = $translate.instant('customerDetails.renewalSummary.msrp');
          }

          renewalSummary.push(summaryColumnNames);

          // Each part of the renewal summary quote
          _.forEach(segment.parts, function(part) {
            // Find out what string we should use for the number of renewals remaining, based on plural categories for the locale
            var priceGuaranteePluralString;
            if (part.priceLock) {
              // $locale.pluralCat is not officially a public method, but there's no other good way to access plural categories
              // for the current locale in Javascript (as opposed to the ngPluralize directive for HTML).
              var renewalsPluralCategory = $locale.pluralCat(part.priceLockYearsRemaining);
              switch (renewalsPluralCategory) {
                case 'one':
                  priceGuaranteePluralString = $translate.instant(
                    'customerDetails.renewalSummary.priceGuaranteeForOneRenewal',
                    {renewals: part.priceLockYearsRemaining}
                  );
                  break;
                case 'few':
                  priceGuaranteePluralString = $translate.instant(
                    'customerDetails.renewalSummary.priceGuaranteeForFewRenewals',
                    {renewals: part.priceLockYearsRemaining}
                  );
                  break;
                case 'other':
                  priceGuaranteePluralString = $translate.instant(
                    'customerDetails.renewalSummary.priceGuaranteeForOtherRenewals',
                    {renewals: part.priceLockYearsRemaining}
                  );
                  break;
                default:
                  priceGuaranteePluralString = $translate.instant(
                    'customerDetails.renewalSummary.priceGuaranteeForManyRenewals',
                    {renewals: part.priceLockYearsRemaining}
                  );
                  break;
              }
            } else {
              priceGuaranteePluralString = $translate.instant(
                'customerDetails.renewalSummary.noPriceGuarantee'
              );
            }

            renewalSummary.push({
              product: translationUtils.sanitizeSafeInstant(productToProdName.get(part.productInfo)),
              partNumber: part.partNumber,
              smrp: part.monthlyRenewalPrice,
              quantity: part.quantity,
              currency: part.currency,
              priceGuarantee: priceGuaranteePluralString,
              msrp: part.totalAnnualRenewalPrice
            });
          });

          // Add the total as a separate row of its own (separated by one empty row)
          summaryTotal.push({
            product: $translate.instant('customerDetails.renewalSummary.total'),
            partNumber: '',
            smrp: '',
            quantity: segment.total.quantity,
            currency: segmentKey,
            priceGuarantee: '',
            msrp: segment.total.msrp
          });
          // Add each segment's data to the renewal section string
          renewalSectionString +=
            ArrayToCsv.convert(renewalSummary) +
            CSV_ROW_SEPARATOR +
            ArrayToCsv.convert(summaryTotal) +
            CSV_ROW_SEPARATOR;
        });
      }

      var purchaseOrderHistory = [{
        plans: $translate.instant('customerDetails.orderHistoryCSVSection.columns.plans'),
        planType: $translate.instant('customerDetails.orderHistoryCSVSection.columns.planType'),
        quantity: $translate.instant('customerDetails.orderHistoryCSVSection.columns.quantity'),
        orderNumber: $translate.instant('customerDetails.orderHistoryCSVSection.columns.orderNumber'),
        poOnOrder: $translate.instant('customerDetails.orderHistoryCSVSection.columns.poOnOrder'),
        unitOfMeasure: $translate.instant('customerDetails.orderHistoryCSVSection.columns.unitOfMeasure'),
        orderDate: $translate.instant('customerDetails.orderHistoryCSVSection.columns.orderDate'),
        orderType: $translate.instant('customerDetails.orderHistoryCSVSection.columns.orderType')
      }];

      if (orders) {
        _.forEach(orders, function(orderItem) {
          const {
            orderType,
            orderNumber,
            orderDate,
            poNumber,
            productType,
            quantity,
            unitOfMeasure,
            productName
        } = orderItem || {};

          purchaseOrderHistory.push({
            plans: productName,
            planType: productType,
            quantity: quantity,
            orderNumber,
            poOnOrder: poNumber,
            unitOfMeasure,
            orderDate: $filter('rcDate')(orderDate),
            orderType
          });
        });
      }


      //Adds 3 new lines between customer details and the order history table
      var sectionSeparator = CSV_ROW_SEPARATOR + CSV_ROW_SEPARATOR + CSV_ROW_SEPARATOR;
      // Customer info
      var csvData = ArrayToCsv.convert(customerDetails) + sectionSeparator;

      // Licenses and status
      if (!shouldShowOrderHistory) {
        csvData +=
          $translate.instant('customerDetails.customerDetailsCsv.licensesAndStatus.title') +
          CSV_ROW_SEPARATOR +
          ArrayToCsv.convert(licensesAndStatus) +
          sectionSeparator;
      }

      // Purchase Authorization history
      csvData +=
        shouldShowOrderHistory
          ? $translate.instant('customerDetails.paHistorySection.newTitle')
          : $translate.instant('customerDetails.paHistorySection.title');

      csvData +=
        CSV_ROW_SEPARATOR +
        ArrayToCsv.convert(orderHistory) +
        sectionSeparator;

      // Order history
      if (shouldShowOrderHistory) {
        csvData +=
          $translate.instant('customerDetails.orderHistoryCSVSection.title') +
          CSV_ROW_SEPARATOR +
          ArrayToCsv.convert(purchaseOrderHistory) +
          sectionSeparator;
      }

      if (renewalQuote) {
        // Renewal Summary, with the total separated by one line
        csvData +=
          $translate.instant('customerDetails.renewalSummary.title') +
          '*' +
          CSV_ROW_SEPARATOR +
          renewalSectionString;
        // Add the disclaimer about quote information
        csvData += '* ' + $translate.instant('customerDetails.renewalSummary.quoteDisclaimer');
        // Add the disclaimer about quote information
        csvData += '* ' + $translate.instant('customerDetails.renewalSummary.signTransactionsDisclaimer');
      }

      return csvData;
    };

    /**
     * @description Gets license count (and/or usage) data for the provided product data object
     *
     * @param {Object} options the options for building the count object
     * @param {Object} options.productData the product data object to get the seat information from
     * @param {Boolean} [options.isUnlimited] if the product is unlimited, we don't want to show counts
     * @param {Boolean} [options.isConsolidatedProduct] true if the productData object is an instance of ConsolidatedProduct
     *
     * @returns {Object} the seat count object
     */
    function getSeatCountObj(options) {
      if (options.isConsolidatedProduct) {
        return {
          paidSeatCount: _.invoke(options.productData, 'getConsumableTotalQuantity'),
          unpaidSeatCount: 0,
          activeSeatCount: _.get(options.productData, 'consumedQuantity', '-'),
          availableSeatCount: _.get(options.productData, 'remainingQuantity', '-'),
          totalSeatCount: _.invoke(options.productData, 'getConsumableTotalQuantity')
        };
      }
      // Order of these properties matters! They will be inserted into the CSV in the order
      // they are added to the object, thus the order they appear in the pick call.
      var result = _.pick(options.productData, [
        'paidSeatCount',
        'unpaidSeatCount',
        'activeSeatCount',
        'availableSeatCount',
        'totalSeatCount'
      ]);
      return options.isUnlimited ? _.mapValues(result, _.constant('-')) : result;
    }
  }
})();
